/**
 * 认证管理模块
 */
import { message } from 'ant-design-vue';

// 白名单页面路径（不需要登录验证的页面）
const WHITE_LIST = [
    '/',
    '/index',
    '/product',
    '/agora',
    '/agoraDes',
    '/solution',
    '/new',
    '/newDes',
	'/pageDes',
    '/contact',
    '/about',
    '/recruit',
    '/energy',
    '/calculate',
    '/dataAI'
];

/**
 * 检查当前页面是否在白名单中
 * @param {string} path 页面路径
 * @returns {boolean}
 */
export function isWhiteList(path) {
    return WHITE_LIST.includes(path);
}

/**
 * 跳转到登录页
 */
export function redirectToLogin() {
    // 直接使用项目的SSO登录机制，不显示提示
    if (window.app && window.app.$tools) {
        window.app.$tools.userLogin(
            location.href, // 登录后跳转回当前页面
            (data) => {
                // 获取到登录地址后直接跳转
                if (data) {
                    window.location.href = data;
                }
            },
            (msg) => {
                message.error(msg || '登录失败');
            }
        );
    }
}

/**
 * 检查登录状态
 * @param {string} currentPath 当前页面路径
 * @returns {boolean} 是否需要登录
 */
export function checkLoginStatus(currentPath) {
    // 如果当前页面在白名单中，不需要登录验证
    if (isWhiteList(currentPath)) {
        return true;
    }
    
    // 对于需要登录的页面，直接允许访问
    // 实际的登录检查在接口拦截器中处理
    return true;
}

/**
 * 处理接口返回的402状态码
 */
export function handleUnauthorized() {
    window.app.$tools.clearCookie("satoken")
    
    // 跳转到登录页
    redirectToLogin();
}
